/**
 * Format monétaire COMPTABLE : contrairement au `formatCurrency` du
 * CurrencyContext (minimumFractionDigits: 0, les centimes sont masqués sur
 * tous les écrans grand public), la comptabilité affiche toujours les
 * décimales — 3 pour le dinar tunisien (millimes), 2 pour l'euro.
 * Fonction pure, sans contexte React, pour rester testable.
 */
export type AccountingCurrency = "TND" | "EUR" | "SAR";

const FRACTION_DIGITS: Record<AccountingCurrency, number> = {
  TND: 3,
  EUR: 2,
  SAR: 2,
};

export function formatAccountingAmount(
  amount: number,
  currency: AccountingCurrency = "TND"
): string {
  const digits = FRACTION_DIGITS[currency] ?? 2;
  const locale = currency === "TND" ? "fr-TN" : currency === "SAR" ? "fr-SA" : "fr-FR";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number.isFinite(amount) ? amount : 0);
}
